import { ArrowPositions } from '@/apps/mwd-v2/state/types/TooltipStore';
import { Station } from '@/components/detailPanel/types/types';
import { formatTime } from '@/utils/dateUtils';

import styles from './MwdTooltip.module.css';

const DetailPanelTooltipInformation = ({ data }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', overflow: 'hidden' }}>
    {data.aankomstActueelGeplandeTijd && (
      <div>
        <div data-testid='actueel-tijd' style={{ fontWeight: 500, display: 'inline' }}>
          Aankomst:{' '}
          {(data.arrivalDelayed || data.arrivalIsEarly) && (
            <span
              style={{
                textDecoration: 'line-through',
                paddingRight: '4px',
              }}
            >
              {formatTime(new Date(data.aankomstActueelGeplandeTijd))}
            </span>
          )}
        </div>
        <div
          data-testid='uitvoer-tijd'
          style={{
            display: 'inline',
            fontWeight: 500,
            color: data.arrivalDelayed
              ? 'var(--tractie-color-content-error-inverse)'
              : data.arrivalIsEarly
                ? 'var(--tractie-color-background-success-subtle)'
                : undefined,
          }}
        >
          {formatTime(new Date(data.aankomstUitvoeringsTijd))}
        </div>
      </div>
    )}
    {data.vertrekActueelGeplandeTijd && (
      <div>
        <div data-testid='actueel-tijd' style={{ fontWeight: 500, display: 'inline' }}>
          Vertrek:{' '}
          {(data.departureDelayed || data.departureIsEarly) && (
            <span
              style={{
                textDecoration: 'line-through',
                paddingRight: '4px',
              }}
            >
              {formatTime(new Date(data.vertrekActueelGeplandeTijd))}
            </span>
          )}
        </div>
        <div
          data-testid='uitvoer-tijd'
          style={{
            display: 'inline',
            fontWeight: 500,
            color: data.departureDelayed
              ? 'var(--tractie-color-content-error-inverse)'
              : data.departureIsEarly
                ? 'var(--tractie-color-background-success-subtle)'
                : undefined,
          }}
        >
          {formatTime(new Date(data.vertrekUitvoeringsTijd))}
        </div>
      </div>
    )}
  </div>
);

const DetailPanelOnTimesTooltipContent = ({
  data,
  arrowPosition,
}: {
  data: Station;
  arrowPosition: ArrowPositions;
}) => {
  return (
    <div
      data-testid='detail-panel-tooltip'
      className={arrowPosition === 'bottom' ? styles.legendRightBottomTooltipStyle : styles.legendRightTopTooltipStyle}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <span>
          <DetailPanelTooltipInformation data={data} />
        </span>
      </div>
    </div>
  );
};

export default DetailPanelOnTimesTooltipContent;
